import { render, staticRenderFns } from "./Torneos.vue?vue&type=template&id=a2343d32&scoped=true"
import script from "./Torneos.vue?vue&type=script&lang=ts&setup=true"
export * from "./Torneos.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Torneos.vue?vue&type=style&index=0&id=a2343d32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2343d32",
  null
  
)

export default component.exports